/** @jsx jsx */
import React, { FC } from "react";
import { jsx } from "theme-ui";

interface CollapsibleAreaProps {
  collapsed: boolean;
}

export const CollapsibleArea: FC<CollapsibleAreaProps> = ({ collapsed, children }) => {
  return !collapsed ? <React.Fragment>{children}</React.Fragment> : null;
};
